var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstaOrange(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_12618",
    "data-name": "Group 12618",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21.526,
    height: 21.48,
    viewBox: "0 0 21.526 21.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4896",
    "data-name": "Rectangle 4896",
    width: 21.526,
    height: 21.48,
    fill: "#ef7b13"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12617",
    "data-name": "Group 12617",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45302",
    "data-name": "Path 45302",
    d: "M21.524,10.733c0,1.945.005,3.891,0,5.836a4.762,4.762,0,0,1-3.6,4.746,5.422,5.422,0,0,1-1.319.156q-5.836.018-11.672.005A4.785,4.785,0,0,1,.1,17.644a5.291,5.291,0,0,1-.1-1.1Q0,10.734,0,4.923A4.778,4.778,0,0,1,3.839.106a5.27,5.27,0,0,1,1.1-.1Q10.763,0,16.586,0a4.777,4.777,0,0,1,4.83,3.822,5.527,5.527,0,0,1,.1,1.148c.01,1.92,0,3.841,0,5.761m-3.8,0a6.962,6.962,0,1,0-6.968,6.954,6.959,6.959,0,0,0,6.968-6.954M19.343,3.59a1.444,1.444,0,0,0-1.462-1.467,1.459,1.459,0,0,0-1.473,1.463A1.483,1.483,0,0,0,17.89,5.05,1.468,1.468,0,0,0,19.343,3.59",
    transform: "translate(0 0)",
    fill: "#ef7b13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45303",
    "data-name": "Path 45303",
    d: "M109.343,105.169a3.948,3.948,0,1,1-3.949-3.946,3.952,3.952,0,0,1,3.949,3.946",
    transform: "translate(-94.628 -94.42)",
    fill: "#ef7b13"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstaOrange);
export default __webpack_public_path__ + "static/media/insta_orange.de60f3a0f986bac0fbec7c3bb3d2db00.svg";
export { ForwardRef as ReactComponent };